import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityService } from '../../shared/security.service';
import { GroupGuard } from '../../shared/group.guard';

@Injectable()
export class EctUserGuard extends GroupGuard {
  constructor(securityService: SecurityService, router: Router) {
    super(securityService, router);

    this.validGroups = ["mc.emp.ect.edit","mc.emp.ect.read"];
  }
}
